import $S from 'theme/settings';
import { request } from '../axios/request';

import {
  FETCH_CUSTOMER_PENDING,
  FETCH_CUSTOMER_REJECTED,
  FETCH_CUSTOMER_FULFILLED,
} from '../constants/customerDetail';
import { fetchToken } from './signin';
import { fetchSms } from './signinWithSms';

const $U = require(`plugins/${process.env.REACT_APP_BRAND_CODE}/platformConfigs/integrationMaps/urls`);

const $STC = require(`plugins/${process.env.REACT_APP_BRAND_CODE}/platformConfigs/staticTextMaps/customer`);

const pending = () => ({
  type: FETCH_CUSTOMER_PENDING,
});

const fulfilled = (response) => ({
  type: FETCH_CUSTOMER_FULFILLED,
  response,
});

const rejected = (error) => ({
  type: FETCH_CUSTOMER_REJECTED,
  error,
});

export const fetchCustomer = (pk) => (dispatch) => {
  dispatch(pending());
  request({ method: 'get', url: `${$U.CUSTOMER_LIST}${pk}/` })
    .then((response) => {
      dispatch(fulfilled(response.data));
    })
    .catch((error) => {
      dispatch(rejected(error));
    });
};

export const signInRequest = (customer) => (dispatch) => {
  const { phone: phone_number, pk, smsCode: sms_code } = customer;
  const url = `${$U.CUSTOMER_LIST}${pk}${$U.CUSTOMER_GET_TOKEN}`;

  if ($S.hasSmsVerificationForLogin) {
    const phone = phone_number && phone_number.replace(/^[0]*(.*)/g, '0$1');
    const params = sms_code ? `?verify=true` : '';
    !Boolean(phone_number)
      ? dispatch(
          rejected({ phone_number: [$STC.CUSTOMER_DETAIL_ERRORS.phone_number] })
        )
      : dispatch(
          fetchSms(
            `${url}${params}`,
            (sms_code && { phone, sms_code }) || { phone }
          )
        );
  } else {
    dispatch(fetchToken(url, { pk }));
  }
};



// WEBPACK FOOTER //
// ./src/actions/customerDetail.js